export const personalInfo = {
  name: "Murtaza Kanchwala",
  title: "Data & AI Architect",
  subtitle: "Resident Solutions Architect",
  bio: "I'm on a mission to make Data and AI simpler, approachable, and impactful for everyone. With years of experience navigating the ever-evolving tech landscape, I've learned that the best solutions don't just work—they make life easier, drive smarter decisions, and inspire innovation.",
  yearsOfExperience: 13,
  email: "murtaza@kanchwala.in",
  location: "United Kingdom",
  social: {
    linkedin: "https://www.linkedin.com/in/murtaza-kanchwala/",
    twitter: "https://twitter.com/imkanchwala",
    github: "https://github.com/imkanchwala",
    facebook: "https://www.facebook.com/murtuza.kanchwala/",
    instagram: "https://www.instagram.com/imkanchwala"
  }
};

export const experience = [
  {
    id: 1,
    period: "2022 - Present",
    title: "Resident Solutions Architect",
    company: "Databricks UK plc",
    location: "United Kingdom",
    description: "Part of the Professional Services group, helping enterprise customers across industries including Healthcare, Taxation, Banking, Finance, Insurance, Public Sector, and Technology with their Data & AI strategy and implementation. Working with Databricks on AWS and Azure, specializing in Apache Spark, Unity Catalog, MLflow, Genie, Lakehouse, Lakebase, and Agentic Workflows using LangChain, LangGraph, and DSPy.",
    technologies: ["Databricks", "Apache Spark", "Unity Catalog", "MLflow", "Genie", "LangChain", "LangGraph", "DSPy", "AWS", "Azure"]
  },
  {
    id: 2,
    period: "2017 - 2022",
    title: "Technical Architect - BigData / Azure / GCP / AWS / Machine Learning / AI",
    company: "YASH Technologies Pvt. Ltd.",
    location: "India / United Kingdom",
    description: "Led the Emerging Tech wing's practice around Azure, GCP, and ML/AI Research projects, delivering capabilities and PoCs. Handled deliveries for Anglo American plc, Right Mechanics inc, John Deere inc, Caterpillar inc. Created entire Data Mesh architecture and managed 4 out of 7 Data Products in Data Analytics wing as a founding member for a Fortune 500 Mining Company.",
    technologies: ["Azure", "GCP", "AWS", "Hadoop", "Spark", "Machine Learning", "DataOps", "Data Mesh"]
  },
  {
    id: 3,
    period: "2016 - 2017",
    title: "Senior Software Engineer - Bigdata",
    company: "ClearTrail Technologies Pvt. Ltd.",
    location: "India",
    description: "Worked on Lawful Interception solutions deployed at Law Enforcement Agencies to monitor real-time threats. Built on-premise data platforms using Spark Streaming, Kafka, Cloudera, Hortonworks, HBase, SQL Server, and Solr for handling networking and communications data with disaster recovery capabilities.",
    technologies: ["Spark Streaming", "Kafka", "Cloudera", "Hortonworks", "HBase", "SQL Server", "Solr", "Real-time Processing"]
  },
  {
    id: 4,
    period: "2015 - 2016",
    title: "Senior Software Engineer - Bigdata / AWS",
    company: "YASH Technologies Pvt. Ltd.",
    location: "India",
    description: "Innovation Group member providing solutions around cloud technologies and data for clients like John Deere inc and Guthy|Renker inc.",
    technologies: ["AWS", "Big Data", "Cloud Architecture"]
  },
  {
    id: 5,
    period: "2012 - 2015",
    title: "Software Engineer - Backend Java and NoSQL",
    company: "Sofmen Technologies Pvt. Ltd.",
    location: "India",
    description: "Backend engineering specializing in REST and SOAP services. Worked on data architecture for SQL and NoSQL systems for clients including CivitasLearning inc, DataCastle RED inc.",
    technologies: ["Java", "NoSQL", "REST", "SOAP", "Backend Development"]
  }
];

export const skills = {
  professional: [
    "Go-to-Market Planning",
    "Leadership",
    "Consulting",
    "Mentorship",
    "Complex Problem-solving",
    "Teamwork & Collaboration",
    "Entrepreneurial Mindset",
    "Active Listening",
    "Written Communication",
    "Reverse Engineering",
    "Creativity"
  ],
  technical: [
    { name: "Apache Spark", category: "Big Data" },
    { name: "Databricks", category: "Platform" },
    { name: "Unity Catalog", category: "Platform" },
    { name: "MLflow", category: "Platform" },
    { name: "Genie", category: "Platform" },
    { name: "Lakehouse", category: "Platform" },
    { name: "Lakebase", category: "Platform" },
    { name: "Delta Lake", category: "Big Data" },
    { name: "Python", category: "Programming" },
    { name: "Scala", category: "Programming" },
    { name: "Java", category: "Programming" },
    { name: "SQL", category: "Programming" },
    { name: "Microsoft Azure", category: "Cloud" },
    { name: "Amazon Web Services", category: "Cloud" },
    { name: "Google Cloud Platform", category: "Cloud" },
    { name: "Machine Learning", category: "AI/ML" },
    { name: "Agentic Workflows", category: "AI/ML" },
    { name: "LangChain", category: "AI/ML" },
    { name: "LangGraph", category: "AI/ML" },
    { name: "DSPy", category: "AI/ML" },
    { name: "Apache Hadoop", category: "Big Data" },
    { name: "Kafka", category: "Big Data" },
    { name: "Spark Streaming", category: "Big Data" },
    { name: "SQL Databases", category: "Database" },
    { name: "NoSQL Databases", category: "Database" },
    { name: "HBase", category: "Database" },
    { name: "Solr", category: "Database" },
    { name: "Data Mesh", category: "Architecture" },
    { name: "Solution Architecture", category: "Architecture" },
    { name: "Data Architecture", category: "Architecture" },
    { name: "DataOps", category: "Operations" },
    { name: "Cloudera", category: "Platform" },
    { name: "Hortonworks", category: "Platform" },
    { name: "Data Strategy & Governance", category: "Strategy" },
    { name: "Agile", category: "Methodology" }
  ]
};

export const education = [
  {
    id: 1,
    period: "2009 - 2012",
    degree: "Bachelor's degree",
    field: "Computer Applications",
    institution: "Devi Ahilya University",
    college: "Maharaja Ranjit Singh College of Professional Sciences",
    location: "Indore, India"
  }
];

export const certifications = [
  {
    id: 1,
    name: "Databricks Certified: Associate Developer for Apache Spark 3.0",
    issuer: "Databricks",
    validTill: "Apr 2025",
    credentialId: "31274905",
    highlight: "Exam Designer"
  },
  {
    id: 2,
    name: "Databricks Certified: Data Engineer Associate",
    issuer: "Databricks",
    validTill: "Jun 2024",
    credentialId: "53642817"
  },
  {
    id: 3,
    name: "Databricks Certified: Data Analyst Associate",
    issuer: "Databricks",
    validTill: "Feb 2025",
    credentialId: "",
    highlight: "Exam Designer"
  },
  {
    id: 4,
    name: "Databricks Certified: Azure Platform Architect",
    issuer: "Databricks",
    validTill: "May 2026",
    credentialId: ""
  },
  {
    id: 5,
    name: "Microsoft Certified: Azure IoT Developer Specialty",
    issuer: "Microsoft",
    validTill: "Aug 2024",
    credentialId: "H497-8431"
  },
  {
    id: 6,
    name: "Microsoft Certified: Azure AI Engineer Associate",
    issuer: "Microsoft",
    validTill: "Jul 2024",
    credentialId: "H480-0240"
  },
  {
    id: 7,
    name: "Microsoft Certified: Azure Data Scientist Associate",
    issuer: "Microsoft",
    validTill: "Jul 2025",
    credentialId: "H472-8927"
  },
  {
    id: 8,
    name: "Microsoft Certified: Azure Data Engineer Associate",
    issuer: "Microsoft",
    validTill: "Jul 2025",
    credentialId: "H455-5786"
  },
  {
    id: 9,
    name: "AWS Certified: Solutions Architect Associate",
    issuer: "Amazon Web Services",
    validTill: "Sep 2025",
    credentialId: "Z26K0CDKQBVQ1GS4"
  },
  {
    id: 10,
    name: "AWS Certified: Data Analytics Specialty",
    issuer: "Amazon Web Services",
    validTill: "Apr 2026",
    credentialId: "0C56JN1271V110GP"
  }
];

export const publications = [
  {
    id: 1,
    title: "Building Scalable Data Lakehouses with Delta Lake",
    type: "Technical Blog",
    platform: "Medium",
    year: "2024",
    url: "#"
  },
  {
    id: 2,
    title: "Building Agents on Databricks Natively with Claude-3.7-Sonnet",
    type: "Conference Talk",
    platform: "Data + AI Summit",
    year: "2023",
    url: "https://youtu.be/Nzd9c7eRaK4?si=SHE48HFhSERHOyQZ"
  },
  {
    id: 3,
    title: "DataOps Best Practices for Enterprise",
    type: "Whitepaper",
    platform: "Databricks",
    year: "2023",
    url: "#"
  },
  {
    id: 4,
    title: "Migrating Legacy Data Warehouses to Cloud",
    type: "Case Study",
    platform: "LinkedIn",
    year: "2022",
    url: "#"
  }
];

export const projects = [
  {
    id: 1,
    title: "Data Mesh Architecture & Implementation",
    client: "Fortune 500 Mining Company",
    description: "Created entire Data Mesh architecture and managed 4 out of 7 Data Products in the Data Analytics wing as a founding member. Led migration to Databricks Lakehouse, processing 100+ TB of data daily with real-time analytics capabilities.",
    technologies: ["Databricks", "Delta Lake", "Apache Spark", "Data Mesh", "Azure"],
    year: "2023-2024",
    impact: "40% cost reduction, 10x query performance improvement, Data Products at scale"
  },
  {
    id: 2,
    title: "Real-time Bio-mechanical Health Analytics Platform",
    client: "Bio-mechanical Startup",
    description: "Built real-time analytics platform on GCP for monitoring bio-mechanical health metrics. Implemented streaming data pipelines processing sensor data with Apache Spark on Dataproc, BigQuery for analytics, and Cloud Functions for serverless compute.",
    technologies: ["GCP", "Apache Spark", "Dataproc", "BigQuery", "Protobuf", "Google Cloud Storage", "Google PubSub", "Cloud Functions"],
    year: "2021",
    impact: "Real-time health monitoring with sub-second latency"
  },
  {
    id: 3,
    title: "Agricultural IoT Analytics Platform",
    client: "Agricultural Equipment Manufacturer",
    description: "Deployed large-scale IoT analytics platform on AWS monitoring 50,000+ farming vehicles, trucks, and agricultural equipment worldwide. Built on EMR with Apache Spark for real-time processing, S3 for data lake, and Lambda functions for event processing.",
    technologies: ["AWS", "EMR", "Apache Spark", "S3", "Avro", "DynamoDB", "Amazon Lambda", "IoT"],
    year: "2022-2023",
    impact: "Real-time insights for 50K+ devices, optimized farming operations"
  },
  {
    id: 4,
    title: "Lawful Interception & Real-time Threat Monitoring",
    client: "Law Enforcement Agencies",
    description: "Deployed on-premise real-time threat monitoring solution for law enforcement using Spark Streaming and Kafka. Built complete data platform with Cloudera, Hortonworks, HBase, SQL Server, and Solr for networking and communications data analysis.",
    technologies: ["Spark Streaming", "Kafka", "Cloudera", "Hortonworks", "HBase", "Solr"],
    year: "2016-2017",
    impact: "Real-time threat detection for national security operations"
  },
  {
    id: 5,
    title: "ML/AI Research & PoC Delivery",
    client: "In-House",
    description: "Led Emerging Tech wing delivering ML/AI research projects, capabilities, and PoCs across Azure, GCP, and AWS. Developed predictive maintenance solutions, data analytics platforms, and machine learning models for Fortune 500 clients.",
    technologies: ["Azure ML", "GCP AI Platform", "MLflow", "Python", "TensorFlow", "AWS SageMaker"],
    year: "2017-2022",
    impact: "60% reduction in unplanned downtime, multiple successful PoC-to-production transitions"
  }
];